export default __webpack_public_path__ + "static/media/rocket_anim_92.195c63a9.png";